import Http from "../services/Providers/Http";

const ENDPOINTS = {
  SEARCH_PERSON: "/api/user/users",
  GET_ROLEGROUPS: "/api/user/getRoleGroups",
  GET_ROLEGROUP: "/api/user/getRoleGroup",
  UPDATE_ROLEGROUP: "/api/user/updateRoleGroup",
  CREATE_ROLEGROUP: "/api/user/createRoleGroup",
};

export default {
  searchPerson: (payload, params) => {
    return Http.get(ENDPOINTS.SEARCH_PERSON, params, null, payload);
  },
  getRoleGroups: (payload, params) => {
    return Http.get(ENDPOINTS.GET_ROLEGROUPS, params, null, payload);
  },
  getRoleGroup: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_ROLEGROUP, body, params, null, payload);
  },
  updateRoleGroup: (body, payload, params) => {
    return Http.post(ENDPOINTS.UPDATE_ROLEGROUP, body, params, null, payload);
  },
  createRoleGroup: (body, payload, params) => {
    return Http.post(ENDPOINTS.CREATE_ROLEGROUP, body, params, null, payload);
  }
}; 